module.exports = __webpack_public_path__ + "static/11-804c16dc1c74253b5aed8edc63e2966b.jpg";